import { confirmable } from 'react-confirm';
import StackedModal from './stacked_modal';
import { useTranslation } from 'react-i18next';

function DisconnectDialog({ show, proceed, title, content, confirmText }) {
  const { t } = useTranslation();
  return (
    <StackedModal
      isOpen={show}
      title={title || t('common:button.disconnect')}
      content={content || t('common:confirmation.disconnect')}
      primaryAction={{
        content: confirmText || t('common:button.confirm'),
        onAction: () => {
          proceed(true);
        },
      }}
      onClose={() => {
        proceed(false);
      }}
    />
  );
}

export default confirmable(DisconnectDialog);
